export const LANGUAGE_VALUE = {
  KO: 'ko',
  EN: 'en'
};

export const LANGUAGE_OPTIONS = [
  {
    value: LANGUAGE_VALUE.KO,
    name: '한국어'
  },
  {
    value: LANGUAGE_VALUE.EN,
    name: 'English'
  }
];
